<template>
  <div class="chart-container">
    <v-card elevation="0" class="chart-card">
      <div ref="chart" class="chart-element"></div>
    </v-card>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";

export default {
  props: {
    solicitudes: {
      type: Object,
      default: () => ({ status: {} }),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    solicitudes: {
      deep: true,
      handler() {
        if (this.chart && this.solicitudes.status) {
          // Obtenemos las llaves y filtramos las que tienen valor distinto de 0
          const allKeys = Object.keys(this.solicitudes.status || {});
          const filteredKeys = allKeys.filter(
            (key) => this.solicitudes.status[key] !== 0
          );
          const filteredSeries = filteredKeys.map(
            (key) => this.solicitudes.status[key]
          );

          // Actualizamos la gráfica con los datos filtrados
          this.chart.updateOptions({ labels: filteredKeys });
          this.chart.updateSeries(filteredSeries);
        }
      },
    },
  },
  methods: {
    renderChart() {
      // Obtenemos las llaves y filtramos las que tienen valor distinto de 0
      const allKeys = Object.keys(this.solicitudes.status || {});
      const filteredKeys = allKeys.filter(
        (key) => this.solicitudes.status[key] !== 0
      );
      const filteredSeries = filteredKeys.map(
        (key) => this.solicitudes.status[key]
      );

      // Definimos los colores y usamos solo la cantidad necesaria según los datos
      const colors = ["#FF7F50", "#D0E6BA", "#20B2AA", "#A9C0D3"];
      const usedColors = colors.slice(0, filteredKeys.length);

      const options = {
        series: filteredSeries,
        chart: {
          height: "100%",
          type: "radialBar",
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 350,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
            },
            track: {
              show: true,
              background: "#f2f2f2",
              opacity: 0.5,
              strokeWidth: "95%",
              margin: 5,
              dropShadow: {
                enabled: false,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
            cornerRadius: "55%",
            strokeLinecap: "round",
            trackSize: "95%",
            barSize: "85%",
            distributed: false,
          },
        },
        stroke: {
          lineCap: "round",
          width: 4,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.5,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        labels: filteredKeys,
        colors: usedColors,
        legend: {
          show: true,
          floating: false,
          position: "bottom",
          offsetY: 0,
          horizontalAlign: "center",
          fontSize: "14px",
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 8,
            radius: 12,
          },
          formatter: function (seriesName) {
            return seriesName;
          },
          itemMargin: {
            vertical: 10,
          },
        },
      };

      this.chart = new ApexCharts(this.$refs.chart, options);
      this.chart.render();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
}

.chart-card {
}

.chart-element {
  width: 100%;
  height: 400px; /* Ajusta la altura a tu preferencia */
  margin-top: -20px; /* Ajusta este valor para mover la gráfica hacia arriba */
}

/* Ajustamos los bordes redondeados en las pistas del radial bar */
:deep(.apexcharts-radialbar-track) path {
  stroke-linecap: round;
}

:deep(.apexcharts-radialbar) path {
  stroke-linecap: round;
}
</style>
